<template>
  <div class="flex">
    <div class="bg-white rounded-md shadow w-full" :class="(primary)?'border-indigo-600 border-2':''">
      <div class="flex flex-wrap -mt-3 p-8">
        <h3 class="text-xl font-medium leading-6 text-gray-900 block pb-8 w-full">{{ $t('applicants.current_location') }}</h3>
        <label class="font-medium pb-5 pr-6 2xl:w-1/3 w-2/4">
          {{ $t('applicants.current_location_type') }}
        </label>
        <div class="pb-5 pr-6 2xl:w-2/3 w-2/4">
          {{ applicant.actual_location_value }}
        </div>
        <label class="font-medium pb-5 pr-6 2xl:w-1/3 w-2/4" v-if="applicant.actual_location_id">
          {{ $t('applicants.prison') }}
        </label>
        <div class="pb-5 pr-6 2xl:w-2/3 w-2/4" v-if="applicant.actual_location_id">
          {{ applicant.actual_location }} {{ (applicant.actual_location_name) ? ' - ' + applicant.actual_location_name : '' }}
        </div>
        <label class="font-medium pb-5 pr-6 2xl:w-1/3 w-2/4" v-if="applicant.actual_location_type === 3">
          {{ $t('applicants.place') }}
        </label>
        <div class="pb-5 pr-6 2xl:w-2/3 w-2/4" v-if="applicant.actual_location_type === 3">
          {{ applicant.actual_location_name}}
        </div>
        <Link class="btn-indigo inline-flex items-center lg:mb-0 max-w-md" :href="`/applicants/${applicant.id}/current-location/edit/`">
          <span>{{ $t('global.update') }}</span>
        </Link>
      </div>
    </div>
  </div>
</template>
<script>
import { Link } from '@inertiajs/inertia-vue3'
export default{
  components:{Link},
  props:{
    applicant: Object,
    primary: Boolean,
  },
  data(){
    return {
      hideInfo: true,
    }
  },
}
</script>
